export default __webpack_public_path__ + "static/media/Digital Keys.0d1d2854.svg";